import * as React from 'react'
import { Text } from '@amzn/dvui/dist/Text'
import { ButtonProps, PrimaryButton } from '@amzn/dvui/dist/Button'
import { AtfTreatmentProps } from '../../reducers/features'
import { isTreatment } from '../../utils/utils'
import * as st from './disneyAction.module.scss'
import * as utilityClasses from '../utilityClasses.module.scss'
import * as cn from 'classnames'

export interface IDisneyActionProps extends AtfTreatmentProps {
  message?: string,
  returnLink?: string
}

export const DisneyAction = ({ message, returnLink, atfTreatment }: IDisneyActionProps) => {
  if (!message || !returnLink) {
    return null
  }

  const atfTreatmentProps: ButtonProps = {
    ...(isTreatment(atfTreatment,'T1', 'T2', 'T3') && {
      forceDoubleHeight: false,
      className: cn(st.disneyButton, utilityClasses.fullWidthPhablet)
    }),
    ...(isTreatment(atfTreatment,'T1', 'T3') && { shape: 'pill' })
  }

  return (
    <div className="avu-full-width-phablet dv-dp-node-dma" data-automation-id="dma-button">
      <PrimaryButton href={returnLink} forceDoubleHeight={true} {...atfTreatmentProps}>
        <Text tag="span" string={message} />
      </PrimaryButton>
    </div>
  )
}
